'use strict';
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './brands.routes';
import BrandsController from './brands.controller';
import BrandsService from './brands.service';
export default angular.module('eeComUiApp.brands', [uiRouter])
    .config(routing)
    .run(function ($rootScope) {
    'ngInject';
    $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
        // if(next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
        // }
    });
})
    .controller('BrandsController', BrandsController)
    .service('BrandsService', BrandsService)
    .name;
//# sourceMappingURL=index.js.map